import React, { useCallback, useState } from 'react';
import { Snackbar } from '@material-ui/core';

export const useManagementSnackbar = () => {
  const [snackBar, setSnackBar] = useState({ open: false, message: null });
  const showSnackBar = useCallback((message, open = true) => {
    setSnackBar({ open, message });
  }, []);

  const snackbar = (
    <Snackbar
      onClose={() => showSnackBar(null, false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={snackBar.open}
      autoHideDuration={2000}
      message={snackBar.message}
    />
  );

  return { showSnackBar, snackbar };
};
